import { Filters, Value } from "./filters";
import { FiltersMetaV2, FilterV2WithValueOnly } from "./filters_v2";
import { Id } from "./id";

export enum PageTarget {
  WorkflowRoles = "roles_index",
  WorkflowEngagements = "engagements_index",
  WorkflowPlanner = "workflow_profiles",
  Profiles = "profiles_index",
  MarketplaceHome = "matching_activities_index",
  ActivitiesInterests = "activities_interests_index",
  MarketplaceInterests = "marketplace_interests_index",
  MarketplaceSaved = "marketplace_saved_index",
  MarketplaceShared = "marketplace_shared_index",
  ActivityFeed = "activities_index",
  BookingModuleProjectsEngagements = "booking_module_engagements_index",
  BookingModuleProjectsRoles = "booking_module_roles_index",
  BookingModuleWorkforce = "booking_module_profiles_index",
  AuditPlanner = "audit_engagements_index",
  Insights = "custom_insights_api",
  Reports = "custom_reports_api"
}

type SavedFiltersCollectionMetadata = {
  id: Id;
  name: string;
  target: PageTarget;
  profileId: Id;
  activityId?: Id | null;
};

export type SavedFilter = SavedFiltersCollectionMetadata & Filters<Value>;

export type SavedFiltersV2 = SavedFiltersCollectionMetadata & {
  collection: FiltersMetaV2<FilterV2WithValueOnly>;
};
